// extracted by mini-css-extract-plugin
module.exports = {"button":"button--E0N6l","open":"open--lK5Jd","icon":"icon--Jjdf7","menu":"menu--a28Wk","item":"item--poK0F","selected":"selected--NUb4K"};